import { useMutation, useQueryClient } from '@tanstack/react-query';
import { notifications } from '@mantine/notifications';
import { useTranslation } from 'react-i18next';
import { AlertApi } from '../../../apis/AlertApi/AlertApi';
import { QueryKeys } from '../../../queryDefaults/QueryKeys';
import { AppMedError } from '../../../error/AppMedError';
import { IClinicalAlert } from '../Alert';

export interface IResolveAlertVariables {
    id: number;
    notes: string;
}

export function useResolveAlert() {
    const queryClient = useQueryClient();
    const { t } = useTranslation();

    return useMutation<IClinicalAlert, AppMedError, IResolveAlertVariables>({
        mutationKey: [QueryKeys.alerts, 'resolve'],
        mutationFn: async ({ id, notes }: IResolveAlertVariables) => {
            return await AlertApi.resolveAlert(id, notes);
        },
        onSuccess: () => {
            queryClient.invalidateQueries({ queryKey: [QueryKeys.alerts] });
            queryClient.invalidateQueries({ queryKey: [QueryKeys.alertDetail] });
            queryClient.invalidateQueries({ queryKey: [QueryKeys.alertSummary] });
            notifications.show({
                title: t('notification.success'),
                message: t('alert.notifications.resolved'),
                color: 'green',
            });
        },
        onError: (error: AppMedError) => {
            notifications.show({
                title: t('notification.error'),
                message: error?.message || t('notification.error'),
                color: 'red',
            });
        },
    });
}
